import { FC, ReactNode } from 'react';
import Grid from '@mui/material/Grid';
import { SxProps, Theme } from '@mui/material/styles';

type Props = {
  left?: ReactNode;
  right?: ReactNode;
  sx?: SxProps<Theme>;
};

const TwoColumn: FC<Props> = ({ left, right, sx }) => (
  <Grid container sx={sx}>
    <Grid item xs={6} sx={{ pr: 2 }}>
      {left}
    </Grid>

    <Grid item xs={6} sx={{ pl: 2 }}>
      {right}
    </Grid>
  </Grid>
);

export default TwoColumn;
